import React from 'react'
import { IconProps } from './types'

export const IconOutlineFire = ({ size = '1em', ...props }: IconProps) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={size}
			height={size}
			fill="none"
			viewBox="0 0 24 24"
			focusable="false"
			{...props}
		>
			<path
				fill="currentColor"
				fillRule="evenodd"
				d="M11.359 2.22a1 1 0 0 1 1.332.07c.93.925 1.884 1.573 2.85 2.21l.185.122c.89.586 1.825 1.201 2.638 2.014A8.975 8.975 0 0 1 21 13 9 9 0 1 1 5.636 6.636a1 1 0 0 1 1.634.331v.003l.002.002m-.002-.005v.001l.013.028a4.197 4.197 0 0 0 .432.691c.114.15.253.312.418.476A12.62 12.62 0 0 0 8 10h1l.447-.894a5.051 5.051 0 0 1-1.314-.943C8.42 6.222 9.25 3.917 11.36 2.221m.623 2.14C10.379 6.05 10 8.32 10 10a1 1 0 0 1-1.447.894 6.998 6.998 0 0 1-2.323-1.86A6.98 6.98 0 0 0 5 13a7 7 0 1 0 11.95-4.95c-.664-.663-1.438-1.173-2.371-1.789l-.14-.092c-.765-.504-1.607-1.07-2.457-1.809Zm-4.71 2.613Zm3.795 3.706a1 1 0 0 1 .952-.68 3.99 3.99 0 0 1 2.81 1.171A3.99 3.99 0 0 1 16 14a4 4 0 1 1-8 0 1 1 0 0 1 1-1h1.283l.784-2.32Zm1.624 1.442-.744 2.198A1 1 0 0 1 11 15h-.733a2 2 0 1 0 2.424-2.878Z"
				clipRule="evenodd"
			/>
		</svg>
	)
}
